<template>
    <div>
        <div class="listing-header">
            <div class="title-breadcrumb">
                <h1 class="title">
                    {{ title }}
                </h1>
            </div>
        </div>

        <div class="columns is-flex-wrap">
            <div class="column is-12">
                <search-bar
                    :onSearch="debouncedOnSearch"
                    tooltipLabel="msg-busca-agro-ass-produto"
                />
            </div>
        </div>

        <div class="registry-wrapper">
            <container-loader v-if="isLoading && !$store.getters.isLoading" />
            <empty-table-message v-if="isEmpty" />
            <b-table v-else :data="produtos" class="data-table">
                <b-table-column
                    v-for="(f, i) in fields"
                    :key="i"
                    :field="f.key"
                    :label="f.key != 'excluir' ? $t(f.key) : ''"
                    :width="f.width"
                    :class="{
                        'excluir-field': f.key == 'excluir',
                    }"
                    :sortable="f.sortable"
                    :custom-sort="f.sortFn"
                    v-slot="props"
                >
                    <div
                        v-if="
                            f.field == 'caminho' &&
                            props.row[f.field] &&
                            ['jpg', 'jpeg', 'png'].includes(
                                props.row['nome']
                                    .split('.')
                                    [props.row['nome'].split('.').length - 1].toLowerCase()
                            )
                        "
                    >
                        <a :href="props.row[f.field]" target="_blank">
                            <img
                                :src="props.row[f.field]"
                                class="img-anexo"
                                :title="props.row['nome']"
                                :alt="props.row['nome']"
                            />
                        </a>
                    </div>
                    <div v-else>
                        {{ props.row[f.key] }}
                    </div>
                </b-table-column>
            </b-table>
            <PaginationViewer
                class="mb-0"
                :resetPagination="pagination.resetPagination"
                :totalItems="pagination.totalRows"
                :perPageOptions="pagination.perPageOptions"
                :optionStarted="pagination.optionStarted"
                @change="updatePagination"
            />
        </div>
    </div>
</template>

<script>
// #71161
import AssOcorrenciaProdutoService from '@/services/agro/ocorrencia/AssOcorrenciaProdutoService' 
import ContainerLoader from '@/components/content/loader/ContainerLoader';

export default {
    components: {
        ContainerLoader,
    },
    props: {
        idagro_ocorrencia: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            service: new AssOcorrenciaProdutoService(this.$http, this.$router),
            produtos: [],
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            fields: [
                // { key: "foto", width: null, sortable: false, sortFn: null },
                { key: 'produto', width: null, sortable: false, sortFn: null },
                { key: 'familia', width: null, sortable: false, sortFn: null },
            ],
            permissao: false,
            title: '',
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            queryFilter: '',
            column: 'descricao',
            order: 'asc',
        };
    },
    created() {
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.carregarDados();
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-aba-geral-' + numberId;
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;

            let params = [this.queryFilter != '' ? this.queryFilter : '.*'];

            this.service
                .findAllProdutosMedia(
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.idagro_ocorrencia,
                    params
                )
                .then(this.mapItems)
                .then((value) => {
                    this.produtos = value;
                    this.isEmpty = this.produtos.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os produtos da ocorrencia!');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },

        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            return body.content.map((m) => {
                return {
                    id: m.idagro_assocorrenciaproduto,
                    codigo: m.idagro_assocorrenciaprodutoerp,
                    produto: m.produto.descricao,
                    familia: m.produto.produtoFamilia.descricao
                        ? m.produto.produtoFamilia.descricao
                        : '---',
                    media:
                        Object.keys(m.media).length === 0 ? null : this.getMediaInfoIfHttp(m.media),
                };
            });
        },

        /* Se os dados de media forem um link externo, mantem midia na tabela, se não retorna null para facilitar manipulação na tela.  */
        getMediaInfoIfHttp(media) {
            if (media.conteudo.indexOf('http') > -1) {
                return media;
            }
            return null;
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
    },
};
</script>
<style lang="scss" scoped>
.page-container {
    .loading {
        opacity: 0.5;
        pointer-events: none;
    }
}
</style>
